import * as React from 'react';
import moment from 'moment';
import * as Dati from '../Dati';
import * as Glob from '../Globale';
import { ChiamaAPI, BottoneAPI, Trad } from '../components/';
import * as Regole from '../components/Regole';

/// <summary>
/// IBaseProps è l'interfaccia di base che devono estendere tutti i componenti per le proprie propietà'
/// </summary>
/// <param name="Lettura">Indica se il componente è leggibile, in caso fosse false andrà oscurato il componente</param>
/// <param name="Scrittura">Indica se il componente è scrivibile, in caso fosse false il controllo è solo leggibile (sempre se attivo in lettura)</param>
/// <param name="Data">Indica a che data bisogna visualizzare i dati nel controllo</param>
export interface IBaseProps extends Dati.IBaseProps {
}

export class BaseComponent<P = {}, S = {}> extends React.Component<P, S> {
    BCC: BaseCommonComponent = new BaseCommonComponent();

    private _DatiCambiati: boolean = true;
    public _BaseCSS: string = "";
    public _Visibile: boolean = true;
    public _Scrittura: boolean = true;
    public _Lettura: boolean = true;
    public _VisibileScrittura: string = "hidden";

    //public _Regole?: string;

    get _Regole(): string | undefined {
        return this.BCC._Regole;
    }

    set _Regole(regole: string | undefined) {
        this.BCC._Regole = regole;
    }

    protected OnErrore(sender: ChiamaAPI | BottoneAPI, errore: Error): any {
        //console.warn("ERRORE", errore);
        Glob.InfoModaleError("ERRORE", errore.message);
    }

    ///this.OnChange = this.OnChange.bind(this);
    ///Con il bind si può scrivere: onChange={this.OnChange}
    ///altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
    ///Permette di valorizzare campi all'interno di una qualsiasi struttura dati, compresi array e dizionari.
    ///Campo: Dato.NomeCampo, Dato.NomeCampo1.NomeCampo2
    ///Array: Dato.NomeCampo[<Indice>], Dato.NomeCampo1[<Indice>].NomeCampo2
    ///Dizionario: Dato.NomeCampo[<Voce>], Dato.NomeCampo1[<Voce>].NomeCampo2
    ///E' possibile utilizzare anche combinazioni di array e dizionari: name={"Tipi[TipiAnag][" + dati.Dati[T].ID_Chiave + "].Selezionato"}
    protected OnChange(e: React.FormEvent<any> | string, valore?: any): void {
        if (typeof (e) == "string") {
            this.OnChangeValoreSincrono(e, valore, () => {
            });
        } else {
            let Lista = e.currentTarget.name == "" ? e.currentTarget.id : e.currentTarget.name;
            this.OnChangeValoreSincrono(Lista, this.BCC.RecuperaValoreDaEvento(e), () => {
            });
        }
    }

    ///this.OnChangeSincrono = this.OnChangeSincrono.bind(this);
    ///Con il bind si può scrivere: onChange={this.OnChangeSincrono}
    ///altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChangeSincrono(e)}
    ///Permette di valorizzare campi all'interno di una qualsiasi struttura dati, compresi array e dizionari.
    ///Campo: Dato.NomeCampo, Dato.NomeCampo1.NomeCampo2
    ///Array: Dato.NomeCampo[<Indice>], Dato.NomeCampo1[<Indice>].NomeCampo2
    ///Dizionario: Dato.NomeCampo[<Voce>], Dato.NomeCampo1[<Voce>].NomeCampo2
    ///E' possibile utilizzare anche combinazioni di array e dizionari: name={"Tipi[TipiAnag][" + dati.Dati[T].ID_Chiave + "].Selezionato"}
    protected OnChangeSincrono(e: React.FormEvent<any>, funzione: () => any): any {
        let Lista = e.currentTarget.name == "" ? e.currentTarget.id : e.currentTarget.name;
        this.OnChangeValoreSincrono(Lista, this.BCC.RecuperaValoreDaEvento(e), funzione);
    }

    protected OnChangeValoreSincrono(nome: string, valore: any, funzione: () => any) {
        if (!this.BCC.SettaValore(this.state, ("Dato." + nome).split('.'), valore, 0)) {
            if (!this.BCC.SettaValore(this.state, ("Dati." + nome).split('.'), valore, 0)) {
                this.BCC.SettaValore(this.state, nome.split('.'), valore, 0);
            }
        }
        this.setState(this.state, funzione);
    }

    protected SettaDatiSalvati() {
        this._DatiCambiati = false;
    }

    protected GetDatiCambiati(): boolean {
        return this._DatiCambiati;
    }

    protected UnisciListaParametri(lista1: Dati.TListaParametri, lista2: Dati.TListaParametri): Dati.TListaParametri {
        return this.BCC.UnisciListaParametri(lista1, lista2);
    }

    protected CopiaListaParametri(lista: Dati.TListaParametri, eliminaVuoti: boolean): Dati.TListaParametri {
        return this.BCC.CopiaListaParametri(lista, eliminaVuoti);
    }

    protected ControlloAutorizzazione(funzione: Glob.Funzioni): boolean {
        return this.BCC.ControlloAutorizzazione(funzione);
    }

    protected RegolaValidazione(campo: string, state: any): Glob.DatiJSON {
        return this.BCC.RegolaValidazione(campo, state);
    }

    protected RegoleCheck(state: any, listaCampiEsclusi: string[] = []): boolean {
        return this.BCC.RegolaCheckState(state, listaCampiEsclusi);
    }
}

export class BasePureComponent<P = {}, S = {}> extends React.PureComponent<P, S> {
    BCC: BaseCommonComponent = new BaseCommonComponent();

    private _DatiCambiati: boolean = true;
    public _BaseCSS: string = "";
    public _Visibile: boolean = true;
    public _Scrittura: boolean = true;
    public _Lettura: boolean = true;
    public _VisibileScrittura: string = "hidden";

    //public _Regole?: string;


    get _Regole(): string | undefined {
        return this.BCC._Regole;
    }

    set _Regole(regole: string | undefined) {
        this.BCC._Regole = regole;
    }

    protected OnErrore(sender: ChiamaAPI | BottoneAPI, errore: Error): any {
        //console.warn("ERRORE", errore);
        Glob.InfoModaleError("ERRORE", errore.message);
        //console.error("ERRORE", errore);
    }

    ///this.OnChange = this.OnChange.bind(this);
    ///Con il bind si può scrivere: onChange={this.OnChange}
    ///altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
    ///Permette di valorizzare campi all'interno di una qualsiasi struttura dati, compresi array e dizionari.
    ///Campo: Dato.NomeCampo, Dato.NomeCampo1.NomeCampo2
    ///Array: Dato.NomeCampo[<Indice>], Dato.NomeCampo1[<Indice>].NomeCampo2
    ///Dizionario: Dato.NomeCampo[<Voce>], Dato.NomeCampo1[<Voce>].NomeCampo2
    ///E' possibile utilizzare anche combinazioni di array e dizionari: name={"Tipi[TipiAnag][" + dati.Dati[T].ID_Chiave + "].Selezionato"}
    protected OnChange(e: React.FormEvent<any> | string, valore?: any): void {
        if (typeof (e) == "string") {
            this.OnChangeValoreSincrono(e, valore, () => {
            });
        } else {
            let Lista = e.currentTarget.name == "" ? e.currentTarget.id : e.currentTarget.name;
            this.OnChangeValoreSincrono(Lista, this.BCC.RecuperaValoreDaEvento(e), () => {
            });
        }
    }

    ///this.OnChangeSincrono = this.OnChangeSincrono.bind(this);
    ///Con il bind si può scrivere: onChange={this.OnChangeSincrono}
    ///altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChangeSincrono(e)}
    ///Permette di valorizzare campi all'interno di una qualsiasi struttura dati, compresi array e dizionari.
    ///Campo: Dato.NomeCampo, Dato.NomeCampo1.NomeCampo2
    ///Array: Dato.NomeCampo[<Indice>], Dato.NomeCampo1[<Indice>].NomeCampo2
    ///Dizionario: Dato.NomeCampo[<Voce>], Dato.NomeCampo1[<Voce>].NomeCampo2
    ///E' possibile utilizzare anche combinazioni di array e dizionari: name={"Tipi[TipiAnag][" + dati.Dati[T].ID_Chiave + "].Selezionato"}
    protected OnChangeSincrono(e: React.FormEvent<any>, funzione: () => any): any {
        let Lista = e.currentTarget.name == "" ? e.currentTarget.id : e.currentTarget.name;
        this.OnChangeValoreSincrono(Lista, this.BCC.RecuperaValoreDaEvento(e), funzione);
    }

    protected OnChangeValoreSincrono(nome: string, valore: any, funzione: () => any) {
        if (!this.BCC.SettaValore(this.state, ("Dato." + nome).split('.'), valore, 0)) {
            if (!this.BCC.SettaValore(this.state, ("Dati." + nome).split('.'), valore, 0)) {
                this.BCC.SettaValore(this.state, nome.split('.'), valore, 0);
            }
        }
        this.setState(this.state, funzione);
    }

    protected SettaDatiSalvati() {
        this._DatiCambiati = false;
    }

    protected GetDatiCambiati(): boolean {
        return this._DatiCambiati;
    }

    protected UnisciListaParametri(lista1: Dati.TListaParametri, lista2: Dati.TListaParametri): Dati.TListaParametri {
        return this.BCC.UnisciListaParametri(lista1, lista2);
    }

    protected CopiaListaParametri(lista: Dati.TListaParametri, eliminaVuoti: boolean): Dati.TListaParametri {
        return this.BCC.CopiaListaParametri(lista, eliminaVuoti);
    }

    protected ControlloAutorizzazione(funzione: Glob.Funzioni): boolean {
        return this.BCC.ControlloAutorizzazione(funzione);
    }

    protected RegolaValidazione(campo: string, state: any): Glob.DatiJSON {
        return this.BCC.RegolaValidazione(campo, state);
    }

    protected RegoleCheck(state: any): boolean {
        return this.BCC.RegolaCheckState(state);
    }
}

class BaseCommonComponent {
    public _DatiCambiati: boolean = true;
    public _BaseCSS: string = "";
    public _Visibile: boolean = true;
    public _Scrittura: boolean = true;
    public _Lettura: boolean = true;
    public _VisibileScrittura: string = "hidden";
    public _Regole?: string;

    constructor() {
        //this._DatiCambiati = datiCambiati;
        //this._BaseCSS = baseCSS;
        //this._Visibile = visibile;
        //this._Scrittura = scrittura;
        //this._Lettura = lettura;
        //this._VisibileScrittura = visibileScrittura;
        //this._Regole = regole;
        let Sessione = Glob.GetSessione();
        document.title = "InAR - " + location.pathname + " - Client: " + Glob.Version + " Server: " + Sessione.Versione + " - " + Sessione.ConfigurazioneCompilazione;
    }

    public GetValueFromString(o: any, s: any, v: any): any {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        var a = s.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (o != "" && k in o) {
                o = o[k];
            } else {
                return v;
            }
        }

        return o;
    }

    public RecuperaValoreDaEvento(e: React.FormEvent<any>): any {
        var Valore: any = null;
        Glob.Log(Glob.LogCat.BaseComponent, false, "Valore", e.currentTarget, e.currentTarget.name, e.currentTarget.value);
        if ((e.currentTarget as HTMLInputElement).type == "checkbox") {
            Valore = e.currentTarget.checked;
        } else if ((e.currentTarget as HTMLInputElement).type == "radio") {
            Valore = e.currentTarget.value;
        } else if ((e.currentTarget as HTMLInputElement).type == "date") {
            if (e.currentTarget.value == "") {
                Valore = undefined;
            } else {
                Valore = new Date(moment(e.currentTarget.value, "YYYY-MM-DD").utc(true).valueOf());
            }
        } else {
            Valore = e.currentTarget.value;
        }

        return Valore;
    }

    public RegolaValidazione(campo: string, state: any): Glob.DatiJSON {
        return Regole.RegolaValidazione(campo, state, this._Regole);
    }

    public RegolaCheckState(state: any, listaCampiEsclusi: string[] = []): boolean {
        let errore: boolean = false;
        let errori: string[] = [];

        if (this._Regole != undefined) {
            errori = Regole.CheckState(state, this._Regole, listaCampiEsclusi);
        }

        if (errori.length > 0) {
            Glob.InfoModaleError("ERRORI", errori);
            errore = true;
        }

        return errore;
    }


    public ControlloAutorizzazione(funzione: Glob.Funzioni): boolean {
        if (Glob.AzioneAbilitata(funzione, Glob.Scrittura)) {
            this._VisibileScrittura = "";
            this._Scrittura = true;
        } else {
            this._Scrittura = false;
        }

        if (Glob.AzioneAbilitata(funzione, Glob.Lettura)) {
            this._Lettura = true;
        } else {
            this._Lettura = false;
        }

        return this._Lettura;
    }

    public SettaValore(oggetto: any, listaProprieta: string[], valore: any, cicli: number): boolean {
        Glob.Log(Glob.LogCat.BaseComponentSettaValore, false, "SettaValore (" + cicli + ",ingresso)", oggetto, listaProprieta, valore);
        if (listaProprieta.length > 0) {
            for (var P in oggetto) {
                var Prop: string = listaProprieta[0];
                var Dict: boolean = Prop.indexOf("[") > -1;
                var Chiavi: string[] = [];
                if (Dict) {
                    Chiavi = Prop.split("[");
                    Chiavi.shift();
                    for (let C in Chiavi) {
                        Chiavi[C] = Chiavi[C].substring(0, Chiavi[C].indexOf("]"));
                    }
                    Prop = Prop.substring(0, Prop.indexOf("["));
                }

                if (P == Prop) {
                    if (listaProprieta.length > 1) {
                        listaProprieta.shift();
                        let Trovato: boolean = false;
                        if (Dict) {
                            switch (Chiavi.length) {
                                case 1:
                                    Trovato = this.SettaValore(oggetto[P][Chiavi[0]], listaProprieta, valore, cicli + 1);
                                    break;
                                case 2:
                                    Trovato = this.SettaValore(oggetto[P][Chiavi[0]][Chiavi[1]], listaProprieta, valore, cicli + 1);
                                    break;
                                case 3:
                                    Trovato = this.SettaValore(oggetto[P][Chiavi[0]][Chiavi[1]][Chiavi[2]], listaProprieta, valore, cicli + 1);
                                    break;
                                default:
                                    Glob.Log(Glob.LogCat.BaseComponentSettaValore, true, "SettaValore (" + cicli + ",troppe voci di dizionario-1)", oggetto, listaProprieta, valore);
                                    break;
                            }
                        } else {
                            Trovato = this.SettaValore(oggetto[P], listaProprieta, valore, cicli + 1);
                        }
                        if (Trovato) {
                            Glob.Log(Glob.LogCat.BaseComponentSettaValore, false, "SettaValore (" + cicli + ",true-terminatore-2)", oggetto, listaProprieta, valore);
                            return true;
                        }
                    } else {
                        if (Dict) {
                            switch (Chiavi.length) {
                                case 1:
                                    oggetto[P][Chiavi[0]] = this.SettaValoreConverti(valore, typeof (oggetto[P][Chiavi[0]]));
                                    break;
                                case 2:
                                    oggetto[P][Chiavi[0]][Chiavi[1]] = this.SettaValoreConverti(valore, typeof (oggetto[P][Chiavi[0]][Chiavi[1]]));
                                    break;
                                case 3:
                                    oggetto[P][Chiavi[0]][Chiavi[1]][Chiavi[2]] = this.SettaValoreConverti(valore, typeof (oggetto[P][Chiavi[0]][Chiavi[1]][Chiavi[2]]));
                                    break;
                                default:
                                    Glob.Log(Glob.LogCat.BaseComponentSettaValore, true, "SettaValore (" + cicli + ",troppe voci di dizionario)", oggetto, listaProprieta, valore);
                                    break;
                            }
                        } else {
                            oggetto[P] = this.SettaValoreConverti(valore, typeof (oggetto[P]));
                        }
                        Glob.Log(Glob.LogCat.BaseComponentSettaValore, false, "SettaValore (" + cicli + ",true)", oggetto, listaProprieta, valore);
                        return true;
                    }
                }
            }
        }
        Glob.Log(Glob.LogCat.BaseComponentSettaValore, false, "SettaValore (" + cicli + ",false)", oggetto, listaProprieta, valore);
        return false;
    }

    private SettaValoreConverti(valore: any, tipo: string): any {
        //TODO Gestire i nullable, e gli altri tipi mancanti
        switch (tipo.toLowerCase()) {
            case "boolean":
                return valore || valore == "true";
            case "number":
                return valore * 1;
            case "date": //Non dovrebbe servire, Date non è un tipo base
                return moment(valore).toDate;
            case "string":
                return valore;
            case "undefined": //Caso di nuove voci in un dictionary
                Glob.Log(Glob.LogCat.BaseComponentSettaValore, false, "SettaValoreConverti: tipo non definito", valore, tipo);
                return valore;
            default:
                if (valore instanceof Date) {
                    return valore;
                } else {
                    if (valore == undefined) {
                        return undefined;
                    } else {
                        Glob.Log(Glob.LogCat.BaseComponentSettaValore, true, "SettaValoreConverti: tipo non gestito", valore, tipo);
                        return valore;
                    }
                }
        }
    }

    public UnisciListaParametri(lista1: Dati.TListaParametri, lista2: Dati.TListaParametri): Dati.TListaParametri {
        let R: Dati.TListaParametri = {}
        for (var P in lista1) {
            R[P] = lista1[P];
        }
        for (var P in lista2) {
            R[P] = lista2[P];
        }
        return R;
    }

    public CopiaListaParametri(lista: Dati.TListaParametri, eliminaVuoti: boolean): Dati.TListaParametri {
        if (eliminaVuoti) {
            for (var P in lista) {
                if (lista[P] == undefined || lista[P] == "" || lista[P] == "0") {
                    delete lista[P];
                }
            }
        }
        return lista;
    }
}



// WEBPACK FOOTER //
// ./src/components/BaseComponent.tsx